import React from 'react';
import { AdminShell } from './Sidebar';
import { StatCard, TableCard } from '../ui/CrmPage';

const EVENTS = [
  { when: 'сегодня, 10:24', who: 'Admin User',   text: 'Создан новый пользователь «manager.almaty»', tone: 'success' },
  { when: 'сегодня, 09:12', who: 'store.bot',    text: 'Обновлена цена товара «Плёнка защитная iPhone 15»', tone: 'info' },
  { when: 'вчера, 18:37',   who: 'sales.lead',   text: 'Продлён договор с клиентом «Too Almaty Trade»', tone: 'brand' },
  { when: 'вчера, 14:02',   who: 'logistics.kz', text: 'Создан путевой лист №W-2026-014', tone: 'info' },
  { when: '14.05, 09:00',   who: 'system',       text: 'Регулярная синхронизация прайса завершена', tone: 'neutral' },
];

export default function HomePage() {
  return (
    <AdminShell title="Дашборд" subtitle="Обзор работы консоли">
      <div className="crmpage crmpage--embedded">
        <div className="crmpage__main">
          <section className="crmpage__stats">
            <StatCard label="Активных пользователей"  value="127"        accent="success" />
            <StatCard label="Продаж за сегодня"       value="₸ 742 000"  accent="brand" wide />
            <StatCard label="Остаток товара"          value="4 321 шт"   accent="info" />
            <StatCard label="Просроченные договоры"   value="3"          accent="warning" />
          </section>

          <TableCard>
            <div className="crmpage__table-wrap">
              <table className="crmpage__table">
                <colgroup>
                  <col />
                  <col style={{ width: 180 }} />
                  <col style={{ width: 160 }} />
                </colgroup>
                <thead>
                  <tr>
                    <th>Событие</th>
                    <th>Кем</th>
                    <th>Когда</th>
                  </tr>
                </thead>
                <tbody>
                  {EVENTS.map((e, i) => (
                    <tr key={i} className="crmpage__row">
                      <td>
                        <div className="crmpage__primary">{e.text}</div>
                      </td>
                      <td>
                        <span className={`crmpage__status crmpage__status--${e.tone}`}>{e.who}</span>
                      </td>
                      <td className="crmpage__date">{e.when}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </TableCard>
        </div>
      </div>
    </AdminShell>
  );
}
